module.exports = __webpack_public_path__ + "static/media/txt.18a9baa1.svg";